import { Heading, Para, Stack } from 'ui-components';
import EditInfoLink from './EditInfoLink';

type Props = {
  customerName: string;
  phoneNumber: string;
  onNameClick: () => void;
  onPhoneClick: () => void;
};

export default function ExistingCustomerHeader({
  customerName,
  phoneNumber,
  onNameClick,
  onPhoneClick,
}: Props) {
  // Some customers give the whole name instead of just the first name, so we will split by space
  const firstName = customerName.split(' ')[0];

  return (
    <Stack gap={3}>
      <Heading variant="h4">
        Wilkommen zurück <strong>{firstName}</strong>
      </Heading>

      <Stack>
        <Para className="italic">
          Ich bin nicht <EditInfoLink onClick={onNameClick}>{firstName}</EditInfoLink>
        </Para>

        <Para className="italic">
          Meine Nummer ist nicht <EditInfoLink onClick={onPhoneClick}>{phoneNumber}</EditInfoLink>
        </Para>
      </Stack>
    </Stack>
  );
}
